<template>
    <div class="HeaderDropdown">
        <div
            class="HeaderDropdown__option"
            @click="$emit('share')"
        >
            <StreamlineIcon
                class="HeaderDropdown__option-icon"
                :icon="Share"
                :stroke="textGrey"
                :size="16"
            />
            Share Review
        </div>
        <div
            class="HeaderDropdown__option"
            @click="$emit('request')"
        >
            <StreamlineIcon
                class="HeaderDropdown__option-icon"
                :icon="Hyperlink3"
                :stroke="textGrey"
                :size="16"
            />
            Customer Info Request Link
        </div>
        <div
            class="HeaderDropdown__option"
            @click="$emit('open-review')"
        >
            <StreamlineIcon
                class="HeaderDropdown__option-icon"
                :icon="Expand6"
                :stroke="textGrey"
                :size="16"
            />
            Open Review Site
        </div>
    </div>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {Share} from "@reviewpush/streamline-regular/lib/interface-essential/Share";
import {Hyperlink3} from "@reviewpush/streamline-regular/lib/interface-essential/LinkUnlink";
import {Expand6} from "@reviewpush/streamline-regular/lib/interface-essential/ExpandRetract";
import {textGrey} from 'style/_colors.scss';

export default {
    name: 'HeaderDropdown',
    components: {
        StreamlineIcon
    },
    data(){
        return {
            Share,
            Hyperlink3,
            Expand6,
            textGrey,
        };
    }
};
</script>
<style lang="scss">
.HeaderDropdown {
    &__option {
        cursor: pointer;
        display: flex;
        align-items: center;
        border-radius: 4px;
        padding:.25rem;
        white-space: nowrap;
        &:hover {
            background: $grey-50;
        }
    }
    &__option-icon {
        margin-right: 0.5rem;
    }
}
</style>
